<!--First row: name and status-->
<div class="flex flex-wrap gap-2">
  <div class="flex-grow-1" style="margin-bottom: 5px">
    <span class="text-bold mr-1">{{ data.name }}</span>
    <!--<span class="contract-type grey-500">{{ data.organisationContractType?.name }}</span>-->
    <span *ngIf="jobIsNotCompatible" class="icon-container" pTooltip="{{ getToolTipInfo() }}"
      ><i class="fa fa-tag tag-icon"></i><i class="fa fa-times-circle error-icon"></i
    ></span>
  </div>
  <div class="flex-shrink-1" *ngIf="showAvailability">
    <div class="icon-row flex-grow-1">
      <div class="icon-item" style="vertical-align: top">
        <span *ngIf="data.isAvailable">
          <i
            class="fa fa-check fa-lg is-available"
            pTooltip="This supplier is available for work"
          ></i>
        </span>
        <span
          *ngIf="data.isAvailable != null && data.isAvailable != undefined && !data.isAvailable"
        >
          <i
            class="fa fa-times-circle fa-lg not-available"
            pTooltip="This supplier is unavailable for work"
          ></i>
        </span>
        <span *ngIf="data.isAvailable == null || data.isAvailable == undefined">
          <i
            class="fa fa-exclamation-triangle fa-lg fa-sm unknown"
            pTooltip="This supplier has not specified their availability"
          ></i>
        </span>
      </div>
    </div>
  </div>
  <div class="flex-shrink-1">
    <span *ngIf="data.status" class="status-{{ data.status.replace(' ', '') }}">{{
      data.status
    }}</span>
  </div>
</div>

<!--Second row: operational - phone number, latest job-->
<div class="flex flex-wrap">
  <div class="flex-grow-1 mt-2">
    <div style="display: flex; flex-wrap: nowrap; flex-grow: 1">
      <div>
        <span *ngIf="data.supplierOperationalData != null" class="font-bold text-gray-600">{{
          data.supplierOperationalData.classification
        }}</span>
        <img
          *ngIf="data.supplierOperationalData != null && data.supplierOperationalData.isTransporter"
          src="assets/images/transported_active.png"
          class="operational-data-transporter"
          pTooltip="This supplier has transporter capability"
        />
        <span
          *ngIf="
            data.supplierOperationalData != null &&
            data.supplierOperationalData.classification == 'Plated'
          "
        >
          <span class="plated-logo">PLATED</span>
        </span>
        <span
          *ngIf="
            data.supplierOperationalData != null &&
            data.supplierOperationalData.classification == 'New'
          "
        >
          <span class="star">
            <span class="greenstar">
              <i class="fa fa-star"></i>
            </span>
          </span>
        </span>
        <span
          *ngIf="
            data.supplierOperationalData != null &&
            data.supplierOperationalData.classification == 'Operational'
          "
        >
          <span class="star">
            <span class="goldstar">
              <i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i>
            </span>
          </span>
        </span>
      </div>
      <div id="supplier-postcode" class="ml-3">
        <i class="fa fa-home" style="opacity: 0.7"></i><span class="ml-1">{{ data.postcode }}</span>
      </div>
      <div>
        <span class="phoneNumber" *ngIf="data.phoneNumber">
          <i class="fa fa-phone" style="opacity: 0.7"></i>&nbsp;<a
            href="tel:{{ data.phoneNumber }}"
            >{{ data.phoneNumber }}</a
          ></span
        >
      </div>
      <div>
        <span class="last-job-complete"
          >Latest Job:
          {{ data.supplierOperationalData?.lastCompletedTaskDate | datex : 'ddd DD MMM' }}</span
        >
      </div>
    </div>
  </div>
</div>

<div>
  <div *ngIf="data.distanceToPickup || data.distanceToDropoff" class="mt-2">
    <span class="mr-2" pTooltip="Distance from first pickup location" *ngIf="data.distanceToPickup">
      <img class="icon-24" src="{{ pickupImageUrl }}" />
      {{ data.distanceToPickup | number : '1.0-0' }} {{ mileString(data.distanceToPickup) }}
    </span>
    <span pTooltip="Distance from last dropoff location" *ngIf="data.distanceToDropoff">
      <img class="icon-24" src="{{ dropoffImageUrl }}" />
      {{ data.distanceToDropoff | number : '1.0-0' }} {{ mileString(data.distanceToDropoff) }}
    </span>
  </div>
</div>
<!--third row: total jobs, last 30, 90, 180 jobs , completion rate-->
<div class="flex flex-wrap mt-3">
  <div class="flex-grow-1 ui-g-12 no-padding">
    <div class="ui-g-3 no-padding grey-500">Total Jobs</div>
    <div class="ui-g-3 no-padding grey-500">Last 30 Days</div>
    <div class="ui-g-3 no-padding grey-500">Last 90 Days</div>
    <div class="ui-g-3 no-padding grey-500">Last 180 Days</div>
  </div>
  <div class="flex-grow-1 ui-g-12 no-padding">
    <div class="ui-g-3 no-padding">
      <span class="jobNumber">{{ data.supplierOperationalData?.totalJobs }} Jobs</span> <br />({{
        getOntimePercentage(data.supplierOperationalData?.completionRateAllJobs)
      }}% on-time)
    </div>
    <div class="ui-g-3 no-padding">
      <span class="jobNumber">{{ data.supplierOperationalData?.jobsInLast30Days }} Jobs</span>
      <br />({{ getOntimePercentage(data.supplierOperationalData?.completionRateLast30Days) }}%
      on-time)
    </div>
    <div class="ui-g-3 no-padding">
      <span class="jobNumber">{{ data.supplierOperationalData?.jobsInLast90Days }} Jobs</span>
      <br />({{ getOntimePercentage(data.supplierOperationalData?.completionRateLast90Days) }}%
      on-time)
    </div>
    <div class="ui-g-3 no-padding">
      <span class="jobNumber">{{ data.supplierOperationalData?.jobsInLast180Days }} Jobs</span>
      <br />({{ getOntimePercentage(data.supplierOperationalData?.completionRateLast180Days) }}%
      on-time)
    </div>
  </div>
</div>

<!--fourth row: additional tagging information-->
<div *ngIf="data.additionalTagStatuses" class="flex flex-wrap mt-3">
  <div style="display: flex; flex-wrap: wrap; flex-grow: 1">
    <div *ngFor="let item of data.additionalTagStatuses; index as i" class="mr-3 mt-1">
      <span class="{{ getDirectStyle() }}" *ngIf="item.toLowerCase().includes('direct')">{{
        item
      }}</span>
      <div *ngIf="item.toLowerCase().includes('contacted')">
        <span class="{{ getContactedCSS(i, false) }}">{{ item }}</span>
        <span class="ml-1"></span
        ><span class="{{ getContactedCSS(i, true) }}">{{ data.additionalTagStatuses[i + 1] }}</span>
      </div>
    </div>
  </div>
</div>

<!--fifth row: task in plan , buttons etc-->
<div class="flex flex-wrap mt-5 mb-2 grid-gap-15">
  <div class="flex-shrink-1">
    <div style="line-height: 24px">
      <span class="jobCountLabel">Tasks in plan: </span>
      <span>
        <a
          class="task-hyperlink"
          *ngIf="!hideActions"
          href="#"
          (click)="onDriverPlanClick(data); $event.preventDefault()"
          >{{ data.taskCount }}
        </a>
      </span>
      <span
        ><a
          class="task-hyperlink"
          *ngIf="!hideActions"
          href="#"
          (click)="onDriverPlanClick(data); $event.preventDefault()"
          >tasks</a
        ></span
      >
    </div>
  </div>
  <div class="flex-grow-1" style="line-height: 24px">
    <div style="padding-right: 5px">
      Carryover Allowed: {{ data.restrictCarryover ? 'No' : 'Yes' }}
    </div>
  </div>
  <div *ngIf="!hideActions">
    <div class="flex-shrink-1 flex grid-gap-5">
      <div
        *ngFor="let action of data.actions"
        class="button-{{ action.label }}"
        (click)="$event.preventDefault(); action.callback(data)"
      >
        {{ action.label }}
      </div>
    </div>
  </div>
</div>

<p-dialog
  header="Tagging Requirements"
  #taggingRequirements
  [(visible)]="showTaggingRequirements"
  [modal]="true"
  [style]="{ width: '450px', height: '350px' }"
  styleClass="dialog-zindex"
  [responsive]="true"
  (onShow)="taggingRequirements.moveOnTop()"
>
  <div class="tagging-requirements-container">
    <tagging-requirements-details
      [requiredTags]="data.requiredTags"
      [supplierTags]="data.supplierTags"
      [jobNumber]="data.jobNumber"
    ></tagging-requirements-details>
  </div>
</p-dialog>
